import { render, staticRenderFns } from "./AccountSupportDetail.vue?vue&type=template&id=5271f762&scoped=true"
import script from "./AccountSupportDetail.vue?vue&type=script&lang=js"
export * from "./AccountSupportDetail.vue?vue&type=script&lang=js"
import style0 from "./AccountSupportDetail.vue?vue&type=style&index=0&id=5271f762&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5271f762",
  null
  
)

export default component.exports